import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Collapse,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Table,
  TableBody,
  //   TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import DialogWrapper from 'components/DialogWrapper';
import { styled } from '@mui/styles';
import TableCell from 'components/TableCell';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { useTranslation } from 'react-i18next';
import ArgonButton from 'components/ArgonButton';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

import ArgonSelect from 'components/ArgonSelect';
import ArgonInput from 'components/ArgonInput';
import ReorderListCustomComponents from 'components/ReorderListCustomComponents';
import RaisingCardButton from 'components/RaisingCardButton';
import Swal from 'sweetalert2';
import borders from 'assets/theme/base/borders';
import selectData from 'options/selectData';

// Helper function to convert label to value (lowercase, no umlauts, spaces to dashes)
const labelToValue = (label) => {
  if (!label) return '';

  // Replace umlauts
  let value = label
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/Ä/g, 'ae')
    .replace(/Ö/g, 'oe')
    .replace(/Ü/g, 'ue')
    .replace(/ß/g, 'ss');

  // Convert to lowercase and replace spaces with dashes
  value = value.toLowerCase().replace(/\s+/g, '-');

  // Remove any special characters
  value = value.replace(/[^a-z0-9-]/g, '');

  return value;
};

const formMinWidth = 200;

const CustomRequiredFields = React.memo(({ formik, onChange }) => {
  return (
    <>
      <Grid item xs={12} sm={12}>
        {/* <Table>
          <TableHead></TableHead>
          <TableBody>
            <TableRow>
              <TableCell width="100%" padding={[1, 1, 1, 0.5]}>
                Additional Data FieldsTo Be Collected With Registration
              </TableCell>
              <TableCell
                width="100%"
                padding={[1, 1, 1, 0.5]}
                sx={{ minWidth: formMinWidth }}>
                {' '}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell width="100%" padding={[1, 1, 1, 0.5]}>
                <ArgonBox lineHeight={1.4}>
                  <ArgonTypography
                    display="block"
                    variant="caption"
                    fontWeight="bold">
                    Country
                  </ArgonTypography>
                  <ArgonTypography
                    variant="caption"
                    color="text"
                    fontWeight="regular">
                    Require each participant to provide the country he wants to
                    represent
                  </ArgonTypography>
                </ArgonBox>
              </TableCell>
              <TableCell align="end" padding={[1, 1, 1, 0.5]}>
                <Switch
                  id="askForCountry"
                  name="askForCountry"
                  onChange={formik.handleChange}
                  checked={formik.values?.askForCountry}
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell width="100%" padding={[1, 1, 1, 0.5]}>
                <ArgonBox lineHeight={1.4}>
                  <ArgonTypography
                    display="block"
                    variant="caption"
                    fontWeight="bold">
                    T-shirt size
                  </ArgonTypography>
                  <ArgonTypography
                    variant="caption"
                    color="text"
                    fontWeight="regular">
                    Require each participant to provide his t-shirt size
                  </ArgonTypography>
                </ArgonBox>
              </TableCell>
              <TableCell align="end" padding={[1, 1, 1, 0.5]}>
                <Switch
                  id="askForTShirtSize"
                  name="askForTShirtSize"
                  onChange={formik.handleChange}
                  checked={formik.values?.askForTShirtSize}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table> */}

        <CustomRequiredFieldsManager
          formik={formik}
          formMinWidth={formMinWidth}
          onChange={onChange}
        />
      </Grid>
    </>
  );
});

CustomRequiredFields.displayName = 'CustomRequiredFields';

// Component for managing custom required fields
const CustomRequiredFieldsManager = React.memo(({ formik, formMinWidth, onChange }) => {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [openSelectionDialog, setOpenSelectionDialog] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [fieldType, setFieldType] = useState('textInput');
  const [fieldName, setFieldName] = useState('');
  const [fieldLabel, setFieldLabel] = useState('');
  const [fieldRequired, setFieldRequired] = useState(true);
  const [fieldBelongsTo, setFieldBelongsTo] = useState('participant');
  const [fieldUnit, setFieldUnit] = useState('');
  const [fieldOptions, setFieldOptions] = useState([]);
  const [newOptionLabel, setNewOptionLabel] = useState('');
  const [newOptionValue, setNewOptionValue] = useState('');

  const [optionsExpanded, setOptionsExpanded] = useState(false);

  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  }));

  const handleExpandClick = () => {
    setOptionsExpanded(!optionsExpanded);
  };

  // Initialisiere customRequiredFields im formik mit den bereitgestellten Daten
  useEffect(() => {
    console.log(
      'CustomRequiredFieldsManager: customRequiredFields: ',
      formik.values.customRequiredFields
    );

    // if (
    //   !formik.values.customRequiredFields ||
    //   formik.values.customRequiredFields.length === 0
    // ) {
    //   // Verwende die Beispieldaten als Standardwerte, wenn keine Daten vorhanden sind
    //   const defaultCustomFields = [
    //     {
    //       required: true,
    //       type: 'countrySelector',
    //       name: 'country',
    //       label: 'Country to represent',
    //       belongsTo: 'registration'
    //     },
    //     {
    //       label: 'T-Shirt Size',
    //       belongsTo: 'participant',
    //       required: true,
    //       options: [
    //         { value: 'XS', label: 'XS' },
    //         { value: 'S', label: 'S' },
    //         { value: 'M', label: 'M' },
    //         { value: 'L', label: 'L' },
    //         { label: 'XL', value: 'XL' },
    //         { label: 'XXL', value: 'XXL' }
    //       ],
    //       type: 'select',
    //       name: 'tShirtSize'
    //     }
    //     // {
    //     //   required: true,
    //     //   belongsTo: 'participant',
    //     //   label: 'Starting Weight Clean & Jerk',
    //     //   name: 'startingWeightCJ',
    //     //   type: 'weightInput',
    //     //   unit: 'Kg'
    //     // },
    //     // {
    //     //   required: true,
    //     //   belongsTo: 'participant',
    //     //   label: 'Starting Weight Snatch',
    //     //   name: 'startingWeightSnatch',
    //     //   type: 'weightInput',
    //     //   unit: 'Kg'
    //     // }
    //   ];

    //   formik.setFieldValue('customRequiredFields', defaultCustomFields, false);
    //   if (onChange) {
    //     onChange(defaultCustomFields);
    //   }
    // }
  }, []);

  const handleOpenSelectionDialog = () => {
    setOpenSelectionDialog(true);
  };

  const handleCloseSelectionDialog = () => {
    setOpenSelectionDialog(false);
  };

  const handleOpenDialog = (field = null) => {
    if (field) {
      // Bearbeiten eines bestehenden Feldes
      setEditingField(field);
      setFieldType(field.type);
      setFieldName(field.name);
      setFieldLabel(field.label);
      setFieldRequired(field.required);
      setFieldBelongsTo(field.belongsTo);
      setFieldUnit(field.unit || '');
      setFieldOptions(field.options || []);
    } else {
      // Neues Feld erstellen
      setEditingField(null);
      setFieldType('textInput');
      setFieldName('');
      setFieldLabel('');
      setFieldRequired(true);
      setFieldBelongsTo('participant');
      setFieldUnit('');
      setFieldOptions([]);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveField = () => {
    // Validierung
    if (!fieldName || !fieldLabel) {
      return;
    }

    // Generiere einen eindeutigen Namen, wenn es ein neues Feld ist
    let uniqueName = fieldName;
    if (!editingField) {
      uniqueName = generateUniqueName(fieldName);
    }

    const newField = {
      type: fieldType,
      name: uniqueName,
      label: fieldLabel,
      required: fieldRequired,
      belongsTo: fieldBelongsTo
    };

    // Füge zusätzliche Eigenschaften je nach Feldtyp hinzu
    if (fieldType === 'weightInput' && fieldUnit) {
      newField.unit = fieldUnit;
    }

    if (fieldType === 'select' && fieldOptions.length > 0) {
      newField.options = fieldOptions;
    }

    // Aktualisiere formik.values.customRequiredFields
    const updatedFields = [...(formik.values.customRequiredFields || [])];

    if (editingField) {
      // Bearbeiten eines bestehenden Feldes
      const index = updatedFields.findIndex(
        (f) => f.name === editingField.name
      );
      if (index !== -1) {
        updatedFields[index] = newField;
      }
    } else {
      // Neues Feld hinzufügen
      updatedFields.push(newField);
    }

    formik.setFieldValue('customRequiredFields', updatedFields, false);
    if (onChange) {
      onChange(updatedFields);
    }
    handleCloseDialog();
  };

  // Hilfsfunktion, um einen eindeutigen Namen zu generieren
  const generateUniqueName = (baseName) => {
    const existingFields = formik.values.customRequiredFields || [];
    let uniqueName = baseName;
    let counter = 1;

    // Prüfen, ob der Name bereits existiert
    while (existingFields.some((field) => field.name === uniqueName)) {
      uniqueName = `${baseName}${counter}`;
      counter++;
    }

    return uniqueName;
  };

  const handleAddPredefinedField = (fieldType) => {
    let newField;

    if (fieldType === 'tShirtSize') {
      // Generiere einen eindeutigen Namen
      const uniqueName = generateUniqueName('tShirtSize');

      newField = {
        label: 'T-Shirt Size',
        belongsTo: 'participant',
        required: true,
        options: [
          { value: 'XS', label: 'XS' },
          { value: 'S', label: 'S' },
          { value: 'M', label: 'M' },
          { value: 'L', label: 'L' },
          { label: 'XL', value: 'XL' },
          { label: 'XXL', value: 'XXL' }
        ],
        type: 'select',
        name: uniqueName
      };

      // Deaktiviere den Standard-T-Shirt-Size-Switch
      formik.setFieldValue('askForTShirtSize', false, false);
    } else if (fieldType === 'country') {
      // Generiere einen eindeutigen Namen
      const uniqueName = generateUniqueName('country');

      newField = {
        required: true,
        type: 'countrySelector',
        name: uniqueName,
        label: 'Country to represent',
        belongsTo: 'registration'
      };

      // Deaktiviere den Standard-Country-Switch
      formik.setFieldValue('askForCountry', false, false);
    }

    if (newField) {
      const updatedFields = [...(formik.values.customRequiredFields || [])];
      updatedFields.push(newField);

      formik.setFieldValue('customRequiredFields', updatedFields, false);
      if (onChange) {
        onChange(updatedFields);
      }
    }

    handleCloseSelectionDialog();
  };

  const handleDeleteField = (field) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedFields = formik.values.customRequiredFields.filter(
          (f) => f.name !== field.name
        );
        formik.setFieldValue('customRequiredFields', updatedFields, false);
        if (onChange) {
          onChange(updatedFields);
        }
        handleCloseDialog();
      }
    });
  };

  const handleAddOption = () => {
    if (newOptionLabel && newOptionValue) {
      setFieldOptions([
        ...fieldOptions,
        { label: newOptionLabel, value: newOptionValue }
      ]);
      setNewOptionLabel('');
      setNewOptionValue('');
    }
  };

  const handleDeleteOption = (index) => {
    const updatedOptions = [...fieldOptions];
    updatedOptions.splice(index, 1);
    setFieldOptions(updatedOptions);
  };

  // const fieldTypeOptions = [
  //   { label: 'Text Input', value: 'textInput' },
  //   { label: 'Weight Input', value: 'weightInput' },
  //   { label: 'Number Input', value: 'numberInput' },
  //   { label: 'Selection', value: 'select' },
  //   { label: 'Country Selector', value: 'countrySelector' }
  // ];

  const fieldTypeOptions = selectData?.customRequiredFieldInputTypes;

  const belongsToOptions = [
    { label: 'Participant', value: 'participant' },
    { label: 'Registration', value: 'registration' }
  ];

  return (
    <>
      <Table>
        <TableHead></TableHead>
        <TableBody>
          <TableRow>
            <TableCell width="100%" padding={[1, 1, 1, 0.5]}>
              Additional Data Collected From Participants During Registration
            </TableCell>
            <TableCell
              width="100%"
              padding={[1, 1, 1, 0.5]}
              sx={{ minWidth: formMinWidth, textAlign: 'right' }}>
              <ArgonButton
                variant="text"
                color="success"
                size="small"
                onClick={() => handleOpenSelectionDialog()}>
                Add Data Field
              </ArgonButton>
            </TableCell>
          </TableRow>

          {formik.values.customRequiredFields?.length === 0 && (
            <TableRow>
              <TableCell colSpan={2} align="center" padding={[1, 1, 1, 0.5]}>
                <ArgonTypography variant="caption" color="text">
                  No custom fields defined
                </ArgonTypography>
              </TableCell>
            </TableRow>
          )}

          {formik.values.customRequiredFields?.map((field, index) => (
            <TableRow key={index}>
              <TableCell width="100%" padding={[1, 1, 1, 0.5]}>
                <ArgonBox
                  lineHeight={1.4}
                  onClick={() => handleOpenDialog(field)}
                  sx={{ cursor: 'pointer' }}>
                  <ArgonTypography
                    display="block"
                    variant="caption"
                    fontWeight="bold">
                    {field.label}
                    {/* {field.required && <span style={{ color: 'red' }}> *</span>} */}
                  </ArgonTypography>

                  <ArgonTypography
                    variant="caption"
                    color="text"
                    fontWeight="regular">
                    Type:{' '}
                    {fieldTypeOptions.find((opt) => opt.value === field.type)
                      ?.label || field.type}
                    {field.unit && `, Unit: ${field.unit}`}
                    {', '}
                    Asked for each:{' '}
                    {field.belongsTo === 'participant'
                      ? 'Participant'
                      : 'Registration'}
                    {field.type === 'select' && field.options && (
                      <>
                        {', '}
                        options:{' '}
                        {field.options.map((opt) => opt.label).join(', ')}
                      </>
                    )}
                  </ArgonTypography>
                </ArgonBox>
              </TableCell>
              <TableCell align="end" padding={[1, 1, 1, 0.5]}>
                <ArgonBox
                  display="flex"
                  justifyContent="flex-end"
                  onClick={() => handleOpenDialog(field)}
                  sx={{ cursor: 'pointer' }}>
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() => handleOpenDialog(field)}
                    sx={{ mr: 1 }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  {/* <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDeleteField(field)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton> */}
                </ArgonBox>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Dialog zur Auswahl des Feldtyps */}
      <DialogWrapper
        title="Add Data Field"
        open={openSelectionDialog}
        onClose={handleCloseSelectionDialog}
        fullWidth
        maxWidth="sm">
        <ArgonBox p={0}>
          <ArgonTypography
            display="block"
            variant="regular"
            fontWeight="bold"
            mb={1}>
            Choose from predefined fields
          </ArgonTypography>

          <ArgonBox display="flex" flexDirection="column" gap={2} mb={2}>
            <ArgonButton
              variant="outlined"
              color="dark"
              onClick={() => handleAddPredefinedField('tShirtSize')}
              fullWidth>
              Add T-Shirt Size Field
            </ArgonButton>

            <ArgonButton
              variant="outlined"
              color="dark"
              onClick={() => handleAddPredefinedField('country')}>
              Add Country Field
            </ArgonButton>
          </ArgonBox>

          <ArgonTypography
            variant="regular"
            color="dark"
            fontWeight="bold"
            mb={1}
            mt={4}>
            Or create your own field
          </ArgonTypography>
          <ArgonBox display="flex" flexDirection="column" gap={2} mt={0}>
            <ArgonButton
              variant="outlined"
              color="dark"
              onClick={() => {
                handleCloseSelectionDialog();
                handleOpenDialog();
              }}
              fullWidth>
              Add Custom Field
            </ArgonButton>
          </ArgonBox>

          <ArgonBox display="flex" justifyContent="flex-end" mt={3}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleCloseSelectionDialog}>
              Cancel
            </ArgonButton>
          </ArgonBox>
        </ArgonBox>
      </DialogWrapper>

      {/* Dialog zum Erstellen/Bearbeiten von Feldern */}
      <DialogWrapper
        title={editingField ? 'Edit Field' : 'Create New Field'}
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm">
        <ArgonBox p={0}>
          <ArgonBox mb={2} mt={2}>
            <ArgonInput
              fullWidth
              label="Field"
              placeholder="What to ask for, e.g. 'T-Shirt Size'"
              tooltip="What to ask for, e.g. 'T-Shirt Size'"
              value={fieldLabel}
              onChange={(e) => {
                const newLabel = e.target.value;
                setFieldLabel(newLabel);
                // Immer den Feldnamen aus dem Label generieren
                if (!editingField) {
                  setFieldName(labelToValue(newLabel));
                }
              }}
              required
              // helperText="Label that is displayed to the user"
              margin="dense"
            />
          </ArgonBox>
          <ArgonBox mb={2}>
            <ArgonSelect
              fullWidth
              placeholder="Select Input Type"
              tooltip="Select the type of input field"
              options={fieldTypeOptions}
              value={fieldTypeOptions.find((opt) => opt.value === fieldType)}
              onChange={(option) => setFieldType(option.value)}
              label="Field Type"
              required
            />
          </ArgonBox>

          {/* Zusätzliche Felder je nach Feldtyp */}
          {fieldType === 'weightInput' && (
            <ArgonBox mb={2}>
              <ArgonInput
                fullWidth
                label="Unit"
                tooltip="Unit of the input field (e.g. Kg, lbs)"
                value={fieldUnit}
                onChange={(e) => setFieldUnit(e.target.value)}
                placeholder="e.g. Kg"
                margin="dense"
              />
            </ArgonBox>
          )}

          {/* Optionen für Auswahlfelder mit ReorderListCustomComponents */}
          {fieldType === 'select' && (
            <ArgonBox mb={2}>
              <ArgonBox
                display="flex"
                alignItems="center"
                justifyContent="space-between">
                <ArgonTypography
                  variant="caption"
                  fontWeight="bold"
                  mb={1}
                  ml={0.5}>
                  Options
                </ArgonTypography>

                {/* <ArgonButton
                  variant="text"
                  color="dark"
                  style={{ padding: 0, textAlign: 'right' }}> */}

                {/* <ExpandMore
                  expand={optionsExpanded}
                  onClick={handleExpandClick}
                  aria-expanded={optionsExpanded}
                  aria-label="show more"
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    marginRight: '3px'
                  }}>
                  <ExpandMoreIcon />
                 
                </ExpandMore> */}

                <ArgonTypography
                  variant="caption"
                  fontWeight="bold"
                  color="secondary"
                  sx={{ cursor: 'pointer' }}
                  onClick={handleExpandClick}>
                  {optionsExpanded ? 'hide' : 'edit'}
                </ArgonTypography>

                {/* </ArgonButton> */}
              </ArgonBox>

              {!optionsExpanded && (
                // {/* summary of the options */}

                <ArgonBox
                  onClick={handleExpandClick}
                  sx={{
                    cursor: 'pointer',
                    border: '1px solid #e0e0e0',
                    borderRadius: borders?.borderRadius?.md,
                    paddingLeft: '10px',
                    paddingRight: '4px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center'
                  }}

                  // onChange={(e) => setNewOptionLabel(e.target.value)}
                >
                  <ArgonTypography variant="regular" color="text">
                    {fieldOptions.map((option) => option.label).join(', ')}
                  </ArgonTypography>
                </ArgonBox>
              )}
              <Collapse in={optionsExpanded}>
                <ReorderListCustomComponents
                  unorderedItems={fieldOptions.map((option) => ({
                    ...option,
                    _id: option._id || `${option.value}-${option.label}`
                  }))}
                  onItemsUpdated={(updatedItems) => {
                    setFieldOptions(updatedItems);
                  }}
                  addItemText="Add Option"
                  editItemText="Edit Option"
                  addItemComponent={OptionForm}
                  editItemComponent={OptionForm}
                  listItemComponent={OptionListItem}
                  dialogSize="sm"
                />
              </Collapse>
            </ArgonBox>
          )}

          <ArgonBox mb={2}>
            <ArgonSelect
              options={belongsToOptions}
              value={belongsToOptions.find(
                (opt) => opt.value === fieldBelongsTo
              )}
              onChange={(option) => setFieldBelongsTo(option.value)}
              label="Asked for each"
              tooltip={
                <>
                  Where to ask for the field; <br />
                  <br />
                  <u>'Participant'</u> means the field is asked for each
                  participant, e.g. 'T-Shirt Size'.
                  <br />
                  <br />
                  <u>'Registration'</u> means the field is asked for each
                  registration (even if there are multiple participants in the
                  same registration), e.g. 'Country to represent'
                </>
              }
              required
              overflow
            />
          </ArgonBox>
          {/* <ArgonBox mb={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={fieldRequired}
                  onChange={(e) => setFieldRequired(e.target.checked)}
                />
              }
              label="Required Field"
            />
          </ArgonBox> */}
          <ArgonBox display="flex" justifyContent="space-between" mt={3}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleCloseDialog}>
              Cancel
            </ArgonButton>

            {/* Rechte Buttons */}
            <ArgonBox display="flex" gap={2} ml={editingField ? 'auto' : 0}>
              {/* Delete Button - nur anzeigen, wenn ein bestehendes Feld bearbeitet wird */}
              {editingField && (
                <ArgonButton
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    handleDeleteField(editingField);
                  }}>
                  Delete
                </ArgonButton>
              )}
              <ArgonButton
                onClick={handleSaveField}
                variant="gradient"
                color="success"
                disabled={
                  !fieldName ||
                  !fieldLabel ||
                  (fieldType === 'select' && fieldOptions.length === 0)
                }>
                Save
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </DialogWrapper>
    </>
  );
});

CustomRequiredFieldsManager.displayName = 'CustomRequiredFieldsManager';

// Component for displaying an option in the list
const OptionListItem = React.memo(({ item, onItemClicked }) => {
  const handleClick = (event) => {
    event.preventDefault();

    // Only call onItemClicked if it's a function and we haven't already handled this click
    if (
      onItemClicked &&
      typeof onItemClicked === 'function' &&
      !event._handled
    ) {
      event._handled = true;
      onItemClicked(item);
    }
  };

  return (
    <Grid
      container
      columnSpacing={1}
      width="100%"
      onClick={handleClick}
      sx={{ cursor: 'pointer' }}>
      <Grid item xs={12}>
        <ArgonTypography variant="caption" fontWeight="bold">
          {item.label}
        </ArgonTypography>
      </Grid>
    </Grid>
  );
});

OptionListItem.displayName = 'OptionListItem';

OptionListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onItemClicked: PropTypes.func
};

// Component for adding/editing an option
const OptionForm = React.memo(({ item, onChange }) => {
  const [option, setOption] = useState(item || { label: '', value: '' });
  // Immer automatisch generieren, unabhängig vom Item
  const autoGenerateValue = true;

  const handleChange = (field, value) => {
    let updatedOption = { ...option, [field]: value };

    // If changing the label and autoGenerateValue is enabled, update the value
    if (field === 'label' && autoGenerateValue) {
      updatedOption.value = labelToValue(value);
    }

    setOption(updatedOption);
    onChange?.(updatedOption);
  };

  return (
    <ArgonBox>
      <ArgonBox mb={2}>
        <ArgonInput
          fullWidth
          label="Label"
          value={option.label || ''}
          onChange={(e) => handleChange('label', e.target.value)}
          required
          margin="dense"
        />
      </ArgonBox>
    </ArgonBox>
  );
});

OptionForm.displayName = 'OptionForm';

OptionForm.propTypes = {
  item: PropTypes.object,
  onChange: PropTypes.func
};

CustomRequiredFields.propTypes = {
  allRequiredCustomFields: PropTypes.array,
  formik: PropTypes.object,
  onChange: PropTypes.func
};

export default CustomRequiredFields;
